import { render, staticRenderFns } from "./ad-target.vue?vue&type=template&id=96bdf7c6&scoped=true"
import script from "./ad-target.vue?vue&type=script&setup=true&lang=js"
export * from "./ad-target.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bdf7c6",
  null
  
)

export default component.exports